import { ChangeDetectionStrategy, Component, HostListener, computed, inject, input } from '@angular/core';
import { ConfirmEventType, Confirmation, ConfirmationService } from '../../services/confirmation.service';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  readonly key = input<string | null>(null);
  readonly styleClass = input('');
  readonly dismissableMask = input(false);

  private readonly confirmationService = inject(ConfirmationService);
  protected readonly confirmation = computed(() => {
    const active = this.confirmationService.confirmation();
    return active && (active.key ?? null) === this.key() ? active : null;
  });

  @HostListener('document:keydown.escape', ['$event'])
  protected onEscape(event: Event): void {
    const confirmation = this.confirmation();
    if (!confirmation || confirmation.closeOnEscape === false) {
      return;
    }
    event.preventDefault();
    this.cancel(confirmation);
  }

  protected accept(confirmation: Confirmation): void {
    this.confirmationService.close();
    confirmation.accept?.();
  }

  protected reject(confirmation: Confirmation): void {
    this.confirmationService.close();
    confirmation.reject?.(ConfirmEventType.REJECT);
  }

  protected cancel(confirmation: Confirmation): void {
    this.confirmationService.close();
    confirmation.reject?.(ConfirmEventType.CANCEL);
  }

  protected onMaskClick(event: MouseEvent, confirmation: Confirmation): void {
    if (this.dismissableMask() && event.target === event.currentTarget) {
      this.cancel(confirmation);
    }
  }
}
